import { Activity } from '@wilson/interfaces';

export function isActivityEndLocationMismatch(
  id: string,
  activities: Activity[],
): boolean {
  const currentActivityIndex = activities.findIndex(
    (activity) => activity.id === id,
  );

  if (
    currentActivityIndex === -1 ||
    currentActivityIndex === activities.length - 1
  ) {
    return false;
  }
  return (
    activities[currentActivityIndex].endLocationId !==
    activities[currentActivityIndex + 1].startLocationId
  );
}
